export default __webpack_public_path__ + "static/media/circleStreak.8db1b4ec.png";